<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1>About the Author</h1>
<p>Aisha Riaz is a young professional who is inspired from leaders around the world to write about organizational issues, employee empowerment, and to make a workplace better for employees. She has recently completed her CIPD studies after graduating from the American College of Dubai with a bachelor’s degree in business. Born and raised in Dubai, she enjoys working in a multicultural environment as she believes that helps her learn different cultures and teachings.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?43f5c178